import { createRouter, createWebHistory } from 'vue-router';
import NotAuthorized from '@/NotAuthorized.vue'
import CaricamentoLite from '@/views/CaricamentoLite.vue'
import LandingPageCaricamento from '@/views/LandingPageCaricamento.vue'
import LandingPageAgf from '@/views/LandingPageAgf.vue'
import Mappa from '@/views/Mappa.vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import PicoEmitter from 'pico-emitter';
const eventBus = new PicoEmitter()
const service = new Service(eventBus)

const routes = [
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: NotAuthorized,
    },
    {
      path: '/map',
      name: 'Mappa',
      component: Mappa
    },
    {
      path: '/landing/internal/:token',
      name: 'LandingPageInternal',
      component: LandingPageAgf
    },
    {
      path: '/landing/:token',
      name: 'LandingPage',
      component: LandingPageCaricamento
    },
    {
      path: '/caricamento-contratto/:token/:tipo/:type',
      name: 'CaricamentoLibero',
      component: CaricamentoLite
    }
];


const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
  if(to.name !== 'Unauthorized'){
    if (to.matched.length > 0) {
      if (to.matched[0].name == 'Mappa') {
        next()
      }else{
        await service.exist_token(to.params.token)
        .then((res) => {                
          if (typeof res == 'object' && Object.keys(res.items).length) {
            to.meta = res.items
            next()
          } else {
            next({ name: 'Unauthorized' })
          }
        })
      }
    } else {
      next({ name: 'Unauthorized' }) 
    }      
  }else{
    if(to.name !== 'Unauthorized'){
      next({ name: 'Unauthorized' })
    }else{
      next()
    }
  }
})



export default router;
